module.exports = __webpack_public_path__ + "315065989ab88ac1f88ed0269db95dfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/directive/loader/loader.svg
// module id = 497
// module chunks = 0